import { IconsSize, IconsStyle } from '../../enums';

const IconPlusComponent = ({
  size,
  style,
  color,
}: {
  size: IconsSize;
  style: IconsStyle;
  color: string;
}) => {
  return style === IconsStyle.OUTLINE ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5013 2.5C12.5013 2.22386 12.2774 2 12.0013 2C11.7252 2 11.5013 2.22386 11.5013 2.5V11.5013H2.5C2.22386 11.5013 2 11.7252 2 12.0013C2 12.2774 2.22386 12.5013 2.5 12.5013H11.5013V21.5024C11.5013 21.7785 11.7252 22.0024 12.0013 22.0024C12.2774 22.0024 12.5013 21.7785 12.5013 21.5024V12.5013H21.5024C21.7785 12.5013 22.0024 12.2774 22.0024 12.0013C22.0024 11.7252 21.7785 11.5013 21.5024 11.5013H12.5013V2.5Z"
        fill={color}
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4286 3.42857C13.4286 3.04969 13.2781 2.68633 13.0102 2.41842C12.7422 2.15051 12.3789 2 12 2C11.6211 2 11.2578 2.15051 10.9898 2.41842C10.7219 2.68633 10.5714 3.04969 10.5714 3.42857V10.5714H3.42857C3.04969 10.5714 2.68633 10.7219 2.41842 10.9898C2.15051 11.2578 2 11.6211 2 12C2 12.3789 2.15051 12.7422 2.41842 13.0102C2.68633 13.2781 3.04969 13.4286 3.42857 13.4286H10.5714V20.5714C10.5714 20.9503 10.7219 21.3137 10.9898 21.5816C11.2578 21.8495 11.6211 22 12 22C12.3789 22 12.7422 21.8495 13.0102 21.5816C13.2781 21.3137 13.4286 20.9503 13.4286 20.5714V13.4286H20.5714C20.9503 13.4286 21.3137 13.2781 21.5816 13.0102C21.8495 12.7422 22 12.3789 22 12C22 11.6211 21.8495 11.2578 21.5816 10.9898C21.3137 10.7219 20.9503 10.5714 20.5714 10.5714H13.4286V3.42857Z"
        fill={color}
      />
    </svg>
  );
};

export default IconPlusComponent;
